// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 1rem;
    font-family: Inter, sans-serif;
    line-height: 1.5;
    color: var(--color-primary-black);
    background-color: var(--body-background-color);
    margin: 0;
}

ul {
    padding: 0;
    margin: 0;
}

a {
    &:hover {
        color: var(--color-primary-red-100);
    }

    &:active {
        color: var(--color-neutrals-gray-100);
    }

    &[disabled] {
        color: var(--color-neutrals-gray-300);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/base.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,iCAAiC;IACjC,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["body {\n    font-size: 1rem;\n    font-family: Inter, sans-serif;\n    line-height: 1.5;\n    color: var(--color-primary-black);\n    background-color: var(--body-background-color);\n    margin: 0;\n}\n\nul {\n    padding: 0;\n    margin: 0;\n}\n\na {\n    &:hover {\n        color: var(--color-primary-red-100);\n    }\n\n    &:active {\n        color: var(--color-neutrals-gray-100);\n    }\n\n    &[disabled] {\n        color: var(--color-neutrals-gray-300);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
